import {
  enableProdMode,
  LOCALE_ID,
  provideAppInitializer,
  inject,
  ErrorHandler,
  importProvidersFrom,
} from '@angular/core';
import { CHAT_ENV } from '@totalenergiescode/springbox-salesforce-chat';
import { environment } from './environments/environment';
import { DatePipe, registerLocaleData } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { httpErrorInterceptor } from './app/core/interceptor/interceptor';
import { loaderInterceptor } from './app/core/interceptor/loader-interceptor';
import { routes } from './app/app.routes';
import { Languages } from './app/route-translate.strategy';
import { DEFAULT_LANGUAGE, i18nInitializer, I18nService, LANGUAGES } from './app/core/service/i18n/i18n.service';
import { ErrorHandlerService } from './app/core/service/error-handler.service';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { LocationStrategy } from '@angular/common';
import { TranslateLocationStrategy } from './app/route-translate.strategy';
import { provideRouter, withPreloading, PreloadAllModules, withRouterConfig } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppComponent } from './app/app.component';
import { LocalityApi } from './app/core/api/locality.api';
import localeFr from '@angular/common/locales/fr';
import localeNl from '@angular/common/locales/nl';
import localeEn from '@angular/common/locales/en';
import { take } from 'rxjs/operators';
import { provideDynatrace } from '@totalenergiescode/springbox-totalenergies-ui-library/shared/dynatrace';

registerLocaleData(localeFr, Languages.fr);
registerLocaleData(localeNl, Languages.nl);
registerLocaleData(localeEn, Languages.en);

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    { provide: CHAT_ENV, useValue: environment.envName },
    ...(environment.dynatraceScriptUrl ? [provideDynatrace(environment.dynatraceScriptUrl)] : []),
    provideTranslateService({
      extend: true,
    }),
    provideTranslateHttpLoader({
      prefix: environment.languageAssetsPath,
      suffix: '.json',
    }),
    importProvidersFrom(FormsModule, ReactiveFormsModule),
    DatePipe,
    CookieService,
    { provide: LOCALE_ID, useValue: 'fr-BE' },
    provideAppInitializer(() => {
      const initializerFn = i18nInitializer(inject(I18nService));
      return initializerFn();
    }),
    provideAppInitializer(() => {
      const localityApi = inject(LocalityApi);
      localityApi.prefetchLocalities().pipe(take(1)).subscribe();
    }),
    {
      provide: LANGUAGES,
      useValue: [Languages.fr, Languages.nl, Languages.en],
    },
    {
      provide: DEFAULT_LANGUAGE,
      useValue: Languages.nl,
    },
    provideHttpClient(withInterceptors([httpErrorInterceptor, loaderInterceptor])),
    // Standalone router configuration replacing AppRoutingModule
    provideRouter(routes, withPreloading(PreloadAllModules), withRouterConfig({ onSameUrlNavigation: 'reload' })),
    { provide: ErrorHandler, useClass: ErrorHandlerService },
    { provide: LocationStrategy, useClass: TranslateLocationStrategy },
    provideAnimations(),
  ],
}).catch((err) => console.error(err));
